import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string | undefined | null): string {
    if (!value) return '';

    let date: Date;
    if (typeof value === 'string') {
      date = new Date(value.replace(' ', 'T'));
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return '';

    const seconds = Math.floor((Date.now() - date.getTime()) / 1000);

    const intervals: { [key: string]: [number, string] } = {
      año: [31536000, 'años'],
      mes: [2592000, 'meses'],
      semana: [604800, 'semanas'],
      día: [86400, 'días'],
      hora: [3600, 'horas'],
      minuto: [60, 'minutos'],
      segundo: [1, 'segundos'],
    };

    for (const key in intervals) {
      const [secs, plural] = intervals[key];
      const count = Math.floor(seconds / secs);
      if (count > 0) {
        return `hace ${count} ${count === 1 ? key : plural}`;
      }
    }

    return 'justo ahora';
  }
}
